import axiosInstance from './axiosInstance';

const authApi = {
    checkAuth: () => axiosInstance.get('/auth/'),
    login: (data) => axiosInstance.post('/auth/login', data), ///auth
    logout: (userId , deviceId) => axiosInstance.get('/auth/logout', {}, {
        headers: {
            'X-User-Id': userId,
            'X-Device-Id': deviceId
        }
    }),
    register: (email, referralId, login, source) => axiosInstance.post('/auth/registration', { email, referralId, login, source }),
    newpassword: (email) => axiosInstance.post('/auth/newpassword', { email }),
    verifyCode: (email, code) => axiosInstance.post('/auth/verify-code', { email, code }),
    verifyTestPassword: (password) => axiosInstance.post('/auth/verifytestpassword', { password }),
    verifyPassword: (email, password, referralId) => axiosInstance.post('/auth/verify-password', { email, password, referralId }),
};

export default authApi;
